export class Modal {
  title: string;
  description: string;
}
